import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PostLoadService {
  constructor(private http: HttpClient) {}
  
  postLoad(data) {
    return this.http.post(environment.apiUrl + "load/addNew", data);
  }
}
